import { data } from '../../svg/AddCircle/data';
import { makeIcon } from '../makeIcon';

export const AddCircle = makeIcon(data, 'add_circle', 'AddCircle');

export default AddCircle;
